import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, MapPin, Clock, Home } from 'lucide-react';
import { PHONE, PHONE_LINK, ADDRESS, SERVICE_PAGES } from '../constants';

export default function Footer() {
  return (
    <footer className="bg-[#0f0f1a] text-white py-12 pb-24 lg:pb-12">
      <div className="max-w-7xl mx-auto px-4">
        <Link to="/" className="flex items-center gap-2.5 mb-10">
          <img
            src="/wappen-wien.svg"
            alt="Wiener Wappen"
            className="h-10 w-auto"
          />
          <div>
            <div className="cabinet font-black text-white text-sm tracking-tight">Wohnungsräumung</div>
            <div className="font-bold text-[#E8722A] text-xs">Wien</div>
          </div>
        </Link>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <h4 className="font-black text-[#E8722A] mb-5 text-xs uppercase tracking-wider">Leistungen</h4>
            <ul className="space-y-2">
              {SERVICE_PAGES.map((s) => (
                <li key={s.slug}>
                  <Link to={s.slug} className="text-[#FAFAF8]/50 hover:text-white text-sm transition-colors">
                    {s.fullTitle}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-black text-[#E8722A] mb-5 text-xs uppercase tracking-wider">Regionen</h4>
            <ul className="space-y-2">
              {[
                { label: 'Räumung Wien', slug: '/' },
                { label: 'Räumung Niederösterreich', slug: '/raeumung-niederoesterreich' },
                { label: 'Räumung Klosterneuburg', slug: '/raeumung-niederoesterreich' },
                { label: 'Räumung Mödling', slug: '/raeumung-niederoesterreich' },
                { label: 'Räumung Wiener Neustadt', slug: '/raeumung-niederoesterreich' },
              ].map((r) => (
                <li key={r.label}>
                  <Link to={r.slug} className="text-[#FAFAF8]/50 hover:text-white text-sm transition-colors">{r.label}</Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-black text-[#E8722A] mb-5 text-xs uppercase tracking-wider">Kontakt</h4>
            <ul className="space-y-3.5 text-sm">
              <li className="flex items-start gap-2.5">
                <MapPin size={14} className="text-[#E8722A] flex-shrink-0 mt-0.5" />
                <span className="text-[#FAFAF8]/50">{ADDRESS}</span>
              </li>
              <li className="flex items-center gap-2.5">
                <Phone size={14} className="text-[#E8722A]" />
                <a href={PHONE_LINK} className="text-[#FAFAF8]/50 hover:text-white font-semibold">{PHONE}</a>
              </li>
              <li className="flex items-center gap-2.5">
                <Clock size={14} className="text-[#E8722A]" />
                <span className="text-[#FAFAF8]/50">Mo–Sa: 07:00–20:00 Uhr</span>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-black text-[#E8722A] mb-5 text-xs uppercase tracking-wider">Rechtliches</h4>
            <ul className="space-y-2">
              {['Impressum', 'Datenschutz', 'AGB'].map((item) => (
                <li key={item}><a href="#" className="text-[#FAFAF8]/50 hover:text-white text-sm transition-colors">{item}</a></li>
              ))}
            </ul>
            <div className="mt-8 p-4 bg-white/5 rounded-xl border border-white/10">
              <p className="text-[#7C9A82] text-xs font-black uppercase tracking-wider mb-1">Platz für Neues.</p>
              <p className="text-[#FAFAF8]/40 text-xs leading-relaxed">Wir kommen. Wir räumen. Sie haben Ruhe.</p>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 text-center text-[#FAFAF8]/30 text-xs">
          © {new Date().getFullYear()} Wohnungsräumung Wien · {ADDRESS} · Alle Rechte vorbehalten.
        </div>
      </div>
    </footer>
  );
}
